export const ROUTING_APP_1 = "app1";
export const ROUTING_APP_2 = "app2";
export const ROUTING_LOGIN = "login";
export const ROUTING_TAB_1 = "tab1";
export const ROUTING_TAB_2 = "tab2";